import { IonContent, IonPage, IonCol, IonRow, IonGrid, IonImg, IonButton, IonLabel, IonIcon, useIonViewDidEnter } from '@ionic/react';
import React, { useState } from 'react';
import PageHeader from '../../components/PageHeader/PageHeader';
import './BiblePlanSelectorPage.scss';
import IRouteInfo from '../../interfaces/IRouteInfo';
import ReadingPlans, { AllReadingPlanCodes } from '../../data/ReadingPlans';
import { ReadingPlanTypesNames } from '../../data/ReadingPlanTypes';
import { AppRouteInfo, AppRouteKeys } from '../../routes/AppRoutes';
import { send } from 'ionicons/icons';
import { useParams } from 'react-router';

const BiblePlanSelectorPage: React.FC<IRouteInfo> = (props: IRouteInfo) => {

  const { groupId } = useParams<{ groupId: string }>();
  const [loadedGroupId, setLoadedGroupId] = useState('')

  useIonViewDidEnter(() => {
    if (groupId) {
      setLoadedGroupId(groupId);
    } else {
      setLoadedGroupId('');
    }
  },[])

  return (
    <IonPage>
      <PageHeader {...props} showBackButton={true} ></PageHeader>
      <IonContent color="light">
        <IonGrid fixed={true}>
          <IonRow >
            <IonCol>
              { AllReadingPlanCodes.map((code, index) =>
                index ?
                <IonGrid key={`reading-plans-${index}`}>
                  <IonRow className="bible-plan-selector-row">
                    <IonCol size="6" sizeXl="6" sizeLg="6" sizeMd="12" sizeSm="12" sizeXs="12" className="bible-plan-selector-banner-container">
                      <IonImg src={`${ReadingPlans[code].sessionsURL}plan-banner.jpg`}></IonImg>
                    </IonCol>
                    <IonCol size="6" sizeXl="6" sizeLg="6" sizeMd="12" sizeSm="12" sizeXs="12" className="bible-plan-selector-description-container">
                      <h2 className="bible-plan-selector-plan-title">{ReadingPlans[code].readingPlan}</h2>
                      <ul className="bible-plan-selector-tags">
                        <li>{ReadingPlanTypesNames[ReadingPlans[code].readingPlanType]}</li>
                        <li>{ReadingPlans[code].completionTime}</li>
                      </ul>
                      <p className="bible-plan-selector-description">{ReadingPlans[code].shortDescription}</p>
                      <IonButton routerLink={`${AppRouteInfo[AppRouteKeys.ReadingScheduler].rootPath}/${code}/new/${loadedGroupId}`}>
                        <IonLabel>Get Started with this plan</IonLabel>
                        <IonIcon slot='end' icon={send}></IonIcon>
                      </IonButton>
                    </IonCol>
                  </IonRow>
                </IonGrid> : ''
              )}
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export default BiblePlanSelectorPage;